// Заголовки авторизации к API (barter-024): в Mini App — подпись initData
// (`tma`), в обычном браузере — пара локального веб-профиля (`web id:secret`).
// Нет ни того, ни другого (офлайн первого запуска) — пусто: анонимные пути
// (например, фидбек) продолжают работать, очередь операций дождётся профиля.

import { twa } from './twa';
import { getWebProfileAuth } from './web-profile';

export async function authHeaders(): Promise<Record<string, string>> {
  const app = twa();
  try {
    const initData = app?.initData;
    if (initData) return { Authorization: `tma ${initData}` };
  } catch {}
  const web = await getWebProfileAuth();
  if (web) return { Authorization: `web ${web.id}:${web.secret}` };
  return {};
}
